import apiServices from './apiServices';
import { getlocalmemberReq, local_member_ui, updateBioDataReq ,feedbackreq, addNoteRequest}  from './dtos';



class memberInfoServices  {
    

     baseSvc = new apiServices();
     client = this.baseSvc.client;

   
    constructor() {
     
      }

    
    getMemberInfo()
    {
      const request = new getlocalmemberReq();
        

      return this.client.get(request)

    }


    updateMemberNotes(note : string)
    {
       
     
      const req =new addNoteRequest();
      req.note = note;
  
      return this.client.post(req);


    }
      
    
    updateMemberInfo(member : local_member_ui)
    {
       
     
      const req = new updateBioDataReq();
      req.member = member;
        return this.client.put(req);


    }
    

}




export default memberInfoServices;
